<div class="col-12 md:col-10 lg:col-8 xl:col-5 m-auto px-4 md:px-0">
    <app-registration-stepper *ngIf="!auth0Id" [currentStep]="1"></app-registration-stepper>
    <div *ngIf="plans.length > 0; else noMatchesTemplate" class="m-0">
      <p-card class="col-12 sm:col-11 md:col-10 xl:col-12 justify-content-center p-0" styleClass="bg-slate-100 p-0 my-2">
        <div class="flex justify-content-center align-items-center">
          <i class="pi pi-check-circle text-2xl font-bold mr-2"></i>
          <h4 class="custom-bold">{{plans.length === 1 ? 'Match Found': plans.length + ' Matches Found'}}</h4>
        </div>

        <p *ngIf="plans.length > 1" class="text-center m-0 mb-3">Select the plan(s) you want to manage.</p>
        <div *ngIf="!auth0Id && plans.length > 1" class="flex justify-content-center">
          <p-chip 
            [ngClass]="{ 'bg-white hover:bg-blue-500 hover:border-slate-200 hover:text-white': !allPlanSelected, 'bg-blue-700 text-white': allPlanSelected }" 
            class="mb-3 px-4 border-1 border-slate-200"
            (click)="selectAllPlans()">
            <ng-container *ngIf="allPlanSelected">
              Select All <i class="pi pi-times-circle"></i>
            </ng-container>
            <ng-container *ngIf="!allPlanSelected">
              Select All
            </ng-container>
          </p-chip>
        </div>        
        <div [ngClass]="{ 'overflow-y-auto max-h-30rem': plans.length > 10 }" class="border rounded p-2">
          <div *ngFor="let plan of plans; let i = index; trackBy: trackByIndex">
          <div [ngClass]="{'selected':highlightSelectedPlan(plan.contractNumber) , 'pointer-events-none opacity-80':(auth0Id && plan.alreadyLinked) }" class="mb-3">
            <p-card class="p-0 m-0" (click)="selectPlan(plan)" data-auto-id="plan-card">
              <p-tag *ngIf="auth0Id && plan.alreadyLinked" icon="pi pi-check" severity="secondary" styleClass="font-normal mb-2" value="Already linked" />
              <p class="p-1 m-0">Plan: {{ plan.filedClientSpecificProductName | titlecase }}</p>
              <p class="p-1 m-0">Number: {{ plan.contractNumber | maskNumber }}</p>
              <p class="p-1 m-0">
                {{ plan.propertyAddr1 }}
              </p>
              <p class="p-1 m-0">
                {{ plan.propertyCity }},
                {{ plan.propertyStateCode }}
                {{ plan.propertyZipCode }}
              </p>
            </p-card>
          </div>
        </div>
        </div>        
        <div class="text-emerald-700 text-sm flex align-items-center justify-content-center mb-1" *ngIf="!auth0Id">
          <i class="pi pi-sparkles me-2 "></i>
          <p>After registering, you can link more plans at any time.</p>
        </div>
        <div class="flex">
          <p-button *ngIf="isLinkButtonHidden()" [disabled]="auth0Id ? !selectedPlan : !selectedPlanMultiple.length" [label]="auth0Id ? 'Link plan' : 'Continue'" [rounded]="true" data-auto-id="my-plan-button"
            (click)="goForward()" class="flex align-items-center justify-content-center w-full" styleClass="w-full" />
        </div>
        <br>
        <div class="flex">
          <p-button label="Back" [rounded]="true" severity="secondary" variant="outlined" data-auto-id="not-my-plan-button"
            (click)="goBack()" class="flex align-items-center justify-content-center w-full"
            styleClass="w-full shadow-button bg-white" />
        </div>
        <div class="col-12 mt-3 text-left" *ngIf="auth0Id">
          Not seeing your property?
          <a
              href="https://www.cinchhomeservices.com/contact-us/"
              target="_blank"
              data-auto-id="contact-us-link"
              class="text-blue-700"
          >
            Contact us.
          </a>
        </div>
        <div class="col-12 mt-2 text-left" *ngIf="auth0Id">
          If this information is incorrect, please call
          <span [innerHTML]=" contactNumFormatted | phone:true" appGaButtonClick [buttonLocation]="planFoundPage"
            [buttonName]="incorrectInfoPhoneNumber">
          </span>
          for assistance.
        </div>
      </p-card>
    </div>
    <ng-template #noMatchesTemplate>
      <p-card styleClass="my-2">
        <div class="flex justify-content-center align-items-center">
          <i class="pi pi-times-circle text-2xl font-bold mr-2"></i>
          <h4 class="my-3 custom-bold">No matches found</h4>
        </div>
        <p class="text-center">
          We couldn't find your plan.<br>Double-check your details and try again.
        </p>
        <div class="flex w-full pt-3">
          <p-button [rounded]="true" label="Go back" data-auto-id="go-back-button" (click)="goBack()"
            class="flex align-items-center justify-content-center w-full" styleClass="w-full"></p-button>
        </div>

        <div class="col-12 mt-3 text-left" *ngIf="auth0Id">
          Not seeing your property?
          <a
              href="https://www.cinchhomeservices.com/contact-us/"
              target="_blank"
              data-auto-id="contact-us-link"
              class="text-blue-700"
          >
            Contact us.
          </a>
        </div>
      </p-card>
    </ng-template>
  </div>
